import { OTHER_DETAIL, PRODUCT_TYPE_OTHER_ID } from 'src/components/pages/sales/business-rule/helper/const'

export const filterProducts = (elem, productType) => {
  if (productType) {
    if (productType === PRODUCT_TYPE_OTHER_ID) {
      //represent option 'Other'
      if (
        elem?.product_relation?.ref_table_detail === OTHER_DETAIL ||
        elem?.product_by_work_unit_relation?.product_relation?.ref_table_detail === OTHER_DETAIL
      ) {
        return true
      }
    }

    if (elem?.product_relation?.product_type_id === productType) {
      return true
    }

    if (elem?.product_by_work_unit_relation?.product_relation?.product_type_id === productType) {
      return true
    }
  }
  return false
}
